import { ARMAZENS, EMBARCADORAS, criarOfertasIniciais, criarViagens } from './dados';

export const ATRASO_SIMULADO_MS = 350;
export const TAMANHO_PADRAO_DA_PAGINA = 15;

export const ofertas = criarOfertasIniciais();
export const viagens = criarViagens(ofertas);

export const todasAsEmpresas = [...EMBARCADORAS, ...Object.values(ARMAZENS)];

export const empresaPorId = (id, rotulo) => todasAsEmpresas.find((empresa) => Number(empresa.id) === Number(id))
    || { id, emp_nome_fantasia: `${rotulo} #${id}`, emp_razao_social: `${rotulo} #${id} Ltda`, emp_cnpj: '00000000000191', emp_municipio: 'Cidade Exemplo', emp_estado: 'MT' };

export const comoLista = (valor) => (Array.isArray(valor) ? valor : valor === undefined || valor === null || valor === '' ? [] : [valor]);

export const normalizar = (texto) => String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const paginar = (itens, parametros) => {
    const porPagina = Number(parametros.per_page) || TAMANHO_PADRAO_DA_PAGINA;
    const pagina = Math.max(1, Number(parametros.page) || 1);

    return {
        data: itens.slice((pagina - 1) * porPagina, pagina * porPagina),
        pagination: { total: itens.length, current_page: pagina, per_page: porPagina, last_page: Math.max(1, Math.ceil(itens.length / porPagina)) },
    };
};

export const contarPor = (itens, campo) => itens.reduce((contagem, item) => ({ ...contagem, [item[campo]]: (contagem[item[campo]] || 0) + 1 }), {});

export const contarComVolumePor = (itens, campo) => itens.reduce((contagem, item) => ({
    ...contagem,
    [item[campo]]: {
        count: (contagem[item[campo]]?.count || 0) + 1,
        volume: (contagem[item[campo]]?.volume || 0) + Number(item.volume || 0),
    },
}), {});

export const falhar = (status, mensagem) => ({ status, data: { message: mensagem, errors: [mensagem] } });
